const REGEX_ENTER = /\r?\n/

export function convertToQuestion(questionId, question, index): ComplianceQuestion {
  const questionSubtext = question.subText
    ? question.subText.split(REGEX_ENTER)
    : undefined

  const number = index + 1
  const ico = (index % 5) + 1

  const answerOptions = Object.keys(question.possibleAnswers)
    .sort((a, b) =>
      question.possibleAnswers[a].localeCompare(question.possibleAnswers[b])
    )
    .map(answerId => {
      return { valueText: answerId, label: question.possibleAnswers[answerId] }
    })

  return {
    id: +questionId,
    questionSubtext,
    number,
    ico,
    question: question.text,
    warning: question.warnings,
    answerOptions,
    possibleAnswers: question.possibleAnswers,
    expectedAnswers: question.expectedAnswers
  }
}

function parseQuestions(responseQuestions): ComplianceQuestion[] {
  const questionsIds = Object.keys(responseQuestions).sort(function (a, b) {
    return responseQuestions[a].sequence - responseQuestions[b].sequence
  })

  return questionsIds.map((questionId, index) => ({
    ...convertToQuestion(questionId, responseQuestions[questionId], index),
    total: questionsIds.length
  }))
}

export default parseQuestions
